/** P17: what the Worker asks of a new account's password and name; the password rule is the sign-in form's (schemas.ts). */
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 72; // bcrypt reads 72 bytes
export const DISPLAY_NAME_MAX_LENGTH = 60;

export const isValidPassword = (v: unknown): v is string =>
  typeof v === 'string' && v.length >= PASSWORD_MIN_LENGTH && v.length <= PASSWORD_MAX_LENGTH;

/** 1 to 60 characters once trimmed, and no control character (a name ends up in emails and the audit trail). */
export const isValidDisplayName = (v: unknown): v is string =>
  typeof v === 'string' && v.trim().length >= 1 && v.trim().length <= DISPLAY_NAME_MAX_LENGTH && !/\p{Cc}/u.test(v);
